import { Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import modalSuccessIcon from 'assets/images/modal-success.svg'
import modalErrorIcon from 'assets/images/modal-error.svg'
import { useEffect, useState } from 'react'

function UnitelModal({ data, ...otherProps }) {
	const { t } = useTranslation()

	const [displayModal, setDisplayModal] = useState(false)
	const onCloseModal = () => setDisplayModal(false)
	useEffect(() => {
		if (data) {
			setDisplayModal(true)
		}
	}, [data])

	return (
		<BaseModal
			show={displayModal}
			onHide={onCloseModal}
			hideDecor={true}
			{...otherProps}
		>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					{data?.data || data?.data?.[0] === 1 ? (
						<img src={modalSuccessIcon} alt="Success" />
					) : (
						<img src={modalErrorIcon} alt="Error" />
					)}
				</Modal.Header>
				<Modal.Body>
					<p
						className="text-center"
						style={{
							fontWeight: 400,
							fontSize: '14px',
							lineHeight: '24px',
							color: 'white',
						}}
					>
						{data?.message ?? t('modal.error')}
					</p>
				</Modal.Body>
			</Container>
		</BaseModal>
	)
}

export default UnitelModal
